import React, { useEffect, useState } from 'react';
import { Button, Card, Container, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { SweetAlert } from '../../components/sweetalert';
import { useNavigate, useParams } from 'react-router-dom';
import { URL } from '../../config/url';
import { LoadingSkeleton } from '../../components/LoadingSkeleton';
import HeaderLabel from '../../components/HeaderLabel';
import Perguntas from '../../services/Perguntas';
import ButtonSaveContent from '../../components/ButtonSaveContent';
import { validaInteiroELimitaCampo } from '../../utilities/validaInteiroELimitaCampo';

const CadastroPerguntas = () => {
  const { handleSubmit, register, setFocus, setValue, reset } = useForm();
  const [loading, setLoading] = useState(false);

  const params = useParams()
  const navigate = useNavigate()

  useEffect(() => {

    setFocus('descricao')

    if (params.id) {
      setLoading(true)
      Perguntas.listId(params.id)
        .then((data) => {
          setValue('descricao', data.data.descricao);
          setValue('ativo', data.data.ativo);
          setValue('sequencia', data.data.sequencia);
        })
        .catch((error) => {
          SweetAlert.error(error.response.data.message, 'Perguntas');
        })
        .finally(() => { setLoading(false) })

    }
  }, []);


  function onSubmit(data) {

    if (data.descricao === '' || data.descricao === undefined || data.descricao === null) {
      return SweetAlert.error('Descrição é um campo obrigatório', 'Perguntas');
    }
    if (data.sequencia === '' || data.sequencia === undefined || data.sequencia === null) {
      return SweetAlert.error('Sequência é um campo obrigatório', 'Perguntas');
    }

    setLoading(true)

    const pergunta = {
      "descricao": data.descricao,
      "ativo": data.ativo,
      "sequencia": data.sequencia,
    }

    if (params.id) {
      Perguntas.update(params.id, pergunta)
        .then((data) => {
          SweetAlert.success('Registro atualizado com sucesso', 'Perguntas')
          navigate(URL.perguntas_lista)
        })
        .catch((error) => {
          SweetAlert.error(error.response.data.message, 'Perguntas');
        })
        .finally(() => { setLoading(false) })
    } else {
      Perguntas.create(pergunta)
        .then((data) => {

          reset()
          SweetAlert.success('Pergunta cadastrada com sucesso', 'Perguntas')

        })
        .catch((error) => {
          SweetAlert.error(error.response.data.message, 'Perguntas');
        })
        .finally(() => {
          setLoading(false)
          setTimeout(() => {
            setFocus('descricao')
          }, 10);
        })
    }

  }


  return (
    <>
      {/* {loading === true ? <Loading /> : ''} */}
      <Container>
        <Form onSubmit={handleSubmit(onSubmit)} className='pt-3'>
          <HeaderLabel
            label='Pergunta'
          />

          <Card className='cardShadow'>
            <Card.Body className='p-3'>
              <Row className='d-flex align-items-end'>
                <Form.Group className="col-12">
                  <Form.Label>Descrição <span style={{ color: 'red' }}>*</span></Form.Label>
                  {loading ? <LoadingSkeleton /> : <Form.Control size='sm' as="textarea" rows={2} {...register('descricao')} />}
                </Form.Group>
                <Form.Group className="col-12 col-lg-3">
                  <Form.Label>Sequência <span style={{ color: 'red' }}>*</span></Form.Label>

                  {loading ? <LoadingSkeleton /> :
                    <Form.Control
                      size='sm'
                      type="text"
                      {...register('sequencia')}
                      onChange={(e) => validaInteiroELimitaCampo(e.target.value, 3, 'sequencia', setValue)}
                    />}

                </Form.Group>
                {params.id ? <Form.Group className="col-12 col-lg-3 mt-2">
                  <Form.Label>Situação</Form.Label>
                  {loading ? <LoadingSkeleton /> : <Form.Select {...register('ativo')} size='sm'>
                    <option value={true}>ATIVO</option>
                    <option value={false}>INATIVO</option>
                  </Form.Select>}
                </Form.Group> : ''}
              </Row>
            </Card.Body>
          </Card>

          <div className='d-flex justify-content-end mt-3 mb-3'>
            <Button variant="success" type="submit" className="col-12 col-lg-auto d-flex align-items-center gap-1" disabled={loading}>
              <ButtonSaveContent />
            </Button>
          </div>

        </Form>
      </Container>
    </>
  );
}

export default CadastroPerguntas;
